import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useNuggetRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathname = location.pathname;
    const searchParams = new URLSearchParams(location.search);

    // Handle legacy pathname format: /nugget=slug
    if (pathname.startsWith('/nugget=')) {
      const slug = pathname.substring('/nugget='.length);

      navigate(`/nuggets?nugget=${slug}`, { replace: true });

      return;
    }

    // Handle query parameter format: ?nugget=slug or /?nugget=slug
    const nuggetSlug = searchParams.get('nugget');

    if (nuggetSlug && (pathname === '/' || pathname === '')) {
      navigate(`/nuggets?nugget=${nuggetSlug}`, { replace: true });

      return;
    }
  }, [location.pathname, location.search, navigate]);
};
